/* eslint-disable semi */
<template>
  <section class="page-container">
    <template v-if="components.length">
      <div
        class="content-wrapper"
        :key="content.hash"
        v-for="content in components"
        :class="getCurrentBlockClass(content)"
        :style="{ 'background-image': getColor(content.metadata) }"
      >
        <v-lazy v-model="content.lazy">
          <component
            class="content"
            :is="content.componentName"
            :model="content"
          />
        </v-lazy>
        <ShareButtons
          v-if="isShareButton(content.componentName)"
          class="share"
        />
      </div>
    </template>

    <v-skeleton-loader
      type="image"
      max-height="100%"
      height="100%"
      class="fuck"
      v-else
    />
  </section>
</template>
<script>
/* eslint-disable quotes */
/* eslint-disable comma-dangle */
/* eslint-disable semi */
import Home from "../contentComponents/ContentType.Home.vue";
import Wysiwyg from "../contentComponents/ContentType.Wysiwyg.vue";
import Tabs from "../contentComponents/tabs/ContentType.Tabs.vue";
import News from "../contentComponents/news/ContentType.News.vue";
import Carousel from "../contentComponents/ContentType.Carousel.vue";
import Forms from "../contentComponents/forms/ContentType.Forms.vue";
import Accordion from "../contentComponents/ContentType.Accordion.vue";
import Partners from "../contentComponents/ContentType.Partners.vue";
import Vacancy from "../contentComponents/Vacancy/ContentType.Vacancy.vue";
import History from "../contentComponents/ContentType.History.vue";
import ShareButtons from "../contentComponents/ContentType.ShareButtons.vue";
import Files from "../contentComponents/ContentType.Files.vue";
import Maps from "../contentComponents/ContentType.Map.vue";
import Sales from "../contentComponents/ContentType.SaleButtons.vue";
import Human from "../contentComponents/ContentType.Human.vue";
import Department from "../contentComponents/ContentType.Department.vue";
import Contacts from "../contentComponents/ContentType.Contacts.vue";
import Grid from "../contentComponents/ContentType.Grid.vue";
import PersonalVideo from "../contentComponents/ContentType.Personal-video.vue";
import { ContentTypes } from "../../models/enums";
import { orderBy } from "lodash";
export default {
  name: "PageControl",
  props: ["model"],
  components: {
    Home,
    Wysiwyg,
    Tabs,
    News,
    Carousel,
    Forms,
    Accordion,
    Partners,
    Vacancy,
    History,
    ShareButtons,
    Files,
    Maps,
    Sales,
    Human,
    Department,
    Contacts,
    Grid,
    PersonalVideo,
  },
  data: () => ({
    // IsShareButton: false,
    // components: null,
  }),
  computed: {
    components: function () {
      return orderBy(this.model.components, ["sortOrder", "asc"]);
    },
  },
  methods: {
    getCurrentBlockClass(contentItem) {
      var styleClass = contentItem?.metadata?.blockType ?? "standart";
      if (contentItem.componentName === ContentTypes.Home) {
        styleClass += " full-height";
      }

      return styleClass;
    },
    getColor: function (metadata) {
      const color = metadata.color != null ? metadata.color.hexa : "#FFFFFF";
      var style = "";
      if (metadata.imageId) {
        style = `linear-gradient(${color}, ${color}), url(${this.$store.getters.getApiBasePath}/file/${metadata.imageId})`;
      } else {
        style = `linear-gradient(${color}, ${color})`;
      }
      return style;
    },
    load() {
      return orderBy(this.model.components, ["sortOrder", "asc"]);
    },
    isShareButton(name) {
      if (name === "sharebuttons") {
        return true;
      }
      return false;
    },
  }
};
</script>
<style lang="scss">
.page-container {
  flex: 1 1 auto;
}
.content-wrapper {
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
}

.v-skeleton-loader__image {
  height: 100% !important;
}
.share {
  margin-top: 20px;
  margin-bottom: 40px;
  margin-left: 20%;
}
</style>
